import { useState } from 'react';
import { useAlert } from '../../../../context/Alert.context';
import { DeleteConfirmationModal } from '../../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import { ALERT_TEXT } from '../../../../constants/content';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';


interface DeletePageModalProps {
  open: boolean;
  onClose: () => void;
  id: string;
  gadgetId: string;
  updateDelete: (id: string, gadgetId: string) => void;
}

export const DeleteServiceInfoModal = ({ open, onClose, id, updateDelete, gadgetId }: DeletePageModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const onDelete = () => {
    API.delete(`${URLS.SERVICE_INFO}/${id}`)
      .then(() => {
        updateDelete(id, gadgetId);
        onClose();
        showAlert({
          message: ALERT_TEXT.SERVICE_INFO_DELETED_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e: any) => {
        showAlert({ message: e.response?.data?.message || e.message, severity: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return (
    <DeleteConfirmationModal
      loading={loading}
      onClose={onClose}
      open={open}
      titleItem={'Service info'}
      onDelete={onDelete}
    />
  );
};
